import script from "./SmsComposeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmsComposeModal.vue?vue&type=script&setup=true&lang=ts"

import "./SmsComposeModal.vue?vue&type=style&index=0&id=3c3b0456&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3b0456"]])

export default __exports__